module.exports = __webpack_public_path__ + "img/XLogo.cc42889b.svg";